<template>
  <div class="page-main">
    <!-- 表格操作条 -->
    <vxe-toolbar ref="refToolbar" size="mini" import export print custom :loading="loading">
      <template #buttons>
        <el-button type="success" size="mini" @click="itemAdd">新增加工商 </el-button>
        <el-button type="danger" size="mini" @click="batchDelete">删除加工商 </el-button>
        <el-button type="primary" size="mini" @click="batchBan">激活/禁用加工商 </el-button>
      </template>
      <template #tools>
        <el-button
          size="mini"
          title="模板下载"
          class="el-icon-notebook-2"
          circle
          plain
          @click="downloadModule"
        />
      </template>
    </vxe-toolbar>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :loading="loading"
      :height="this.$util.getViewHeight() - 148"
      :data="tableDataMain"
      :import-config="importConfig"
      :columns="tableColumn"
      :mouse-config="{ selected: false }"
      :export-config="{ type: ['xlsx'], types: ['xlsx'] }"
    >
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          @change="headerFilterChange"
        />
      </template>
      <template #header_used_name="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          url="/admin/gcvip/processorStart/searchHeard"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_operate="{ row }">
        <el-link type="success" @click="itemSync(row)">同步UUID</el-link>
        <el-link type="primary" @click="itemEdit(row)">编辑</el-link>
        <el-link type="danger" @click="itemDelete(row)">删除</el-link>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改加工商 -->
    <PopupProcessor
      v-if="isShowPopupProcessor"
      :show.sync="isShowPopupProcessor"
      :data.sync="itemObj"
      @success="getListData"
    />

    <!-- 弹窗-同步 -->
    <PopupSync v-if="isShowPopupSync" :show.sync="isShowPopupSync" :data.sync="itemSyncObj" />

    <!-- 弹窗-导入 -->
    <PopupImport
      v-if="isShowPopupImport"
      :show.sync="isShowPopupImport"
      :isError="isError"
      :uuid="uuid"
      :list="importTableData"
      @success="getListData"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupProcessor: () => import('./popup-processor'),
    PopupSync: () => import('./popup-sync'),
    PopupImport: () => import('./popup-import')
  },
  data() {
    return {
      loading: true,

      remvoeIds: [],
      banIds: [],

      filterData: {},
      sortData: {},
      headerFilterUrl: '/admin/gcvip/processor/searchHeard',
      tableColumn: [
        {
          type: 'checkbox',
          width: 40
        },
        {
          field: 'id',
          title: '加工商编号',
          slots: { header: 'header_input' }
        },
        {
          field: 'company_name',
          title: '加工商名称',
          slots: { header: 'header_input' }
        },
        {
          field: 'used_name',
          title: '曾用名',
          slots: { header: 'header_used_name' }
        },
        {
          field: 'linkman',
          title: '联系人',
          slots: { header: 'header_input' }
        },
        {
          field: 'linkman_phone',
          title: '联系电话',
          slots: { header: 'header_input' }
        },
        {
          field: 'remark',
          title: '备注',
          slots: { header: 'header_input' }
        },
        {
          field: 'state',
          title: '状态',
          slots: { header: 'header_input' }
        },
        {
          title: '操作',
          width: 160,
          slots: { default: 'default_operate' }
        }
      ],
      tableDataMain: [],
      importConfig: {
        remote: true,
        importMethod: this.importMethod,
        modes: ['insert'],
        type: ['xlsx'],
        types: ['xlsx']
      },
      pageOptions: {
        ...this.$constant.page
      },

      isShowPopupProcessor: false,
      itemDefault: {
        id: '',
        company_name: '',
        linkman: '',
        linkman_phone: '',
        remark: '',
        address: '',
        used_name: '',
        short_name: '',
        state: '激活',
        machine_list: []
      },
      itemObj: {},

      isShowPopupSync: false,
      itemSyncObj: {
        id: '',
        company_uuid: '',
        customer_uuid: '', // 将要成为的客户uuid
        company_name: '' // 将要成为的客户名称
      },

      isShowPopupImport: false,
      isError: '',
      uuid: '',
      importTableData: []
    }
  },
  created() {
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.refTable.connect(this.$refs.refToolbar)
      this.initItemObj()
      this.getListData()
    })
  },
  methods: {
    // 初始化itemObj
    initItemObj() {
      this.itemObj = this.$util.deepCopy(this.itemDefault)
    },
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取数据列表
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/processor/list',
        data: {
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          sortData: this.sortData,
          filterData: this.filterData
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableDataMain = res.data.page.list
            this.pageOptions.pageSize = res.data.page.pageSize
            this.pageOptions.total = res.data.page.totalRow
            this.pageOptions.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 项-新增
    itemAdd() {
      this.isShowPopupProcessor = true
      this.initItemObj()
    },
    // 项-编辑
    itemEdit(row) {
      this.isShowPopupProcessor = true
      this.itemObj = this.$util.deepCopy(row)
    },
    // 项-同步uuid
    itemSync(row) {
      this.isShowPopupSync = true
      this.itemSyncObj = this.$util.deepCopy(row)
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/processor/deleteVue',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    },
    // 批量-激活/禁用
    batchBan() {
      const $grid = this.$refs.refTable
      const selectRecords = $grid.getCheckboxRecords()
      this.banIds = []
      for (let i = 0; i < selectRecords.length; i++) {
        this.banIds.push(selectRecords[i].id)
      }
      if (selectRecords.length > 0) {
        this.$confirm(`您确认要激活/禁用${this.banIds.length}个加工商?`, '提示')
          .then(() => {
            this.$api({
              method: 'get',
              url: '/admin/gcvip/processor/banBatchVue',
              params: {
                banIds: this.banIds
              }
            }).then((res) => {
              if (res.status === 200 && res.data.state === 'ok') {
                this.$message.success('批量删除成功')
                this.getListData()
              }
            })
          })
          .catch(() => {})
      } else {
        this.$message.error('请先选择')
      }
    },
    // 批量-删除
    batchDelete() {
      const $grid = this.$refs.refTable
      const selectRecords = $grid.getCheckboxRecords()
      this.remvoeIds = []
      for (let i = 0; i < selectRecords.length; i++) {
        this.remvoeIds.push(selectRecords[i].id)
      }
      if (selectRecords.length > 0) {
        this.$confirm(`您确认要删除${this.remvoeIds.length}条数据?`, '提示')
          .then(() => {
            this.$api({
              method: 'get',
              url: '/admin/gcvip/processor/deleteBatchVue',
              params: {
                remvoeIds: this.remvoeIds
              }
            }).then((res) => {
              if (res.status === 200 && res.data.state === 'ok') {
                this.$message.success('批量删除成功')
                this.getListData()
              }
            })
          })
          .catch(() => {})
      } else {
        this.$message.error('请先选择')
      }
    },
    // 模板下载
    downloadModule() {
      window.open('/template/supplier.xlsx', '_blank')
    },
    // 导入方法
    importMethod({ file }) {
      const formBody = new FormData()
      formBody.append('file', file)
      this.$api({
        method: 'post',
        url: '/admin/gcvip/processor/importExcel',
        data: formBody
      }).then((res) => {
        if (res.status === 200 && res.data.state === 'ok') {
          this.isError = res.data.isError
          if (res.data.isError == true) {
            this.importTableData = res.data.supplierListError
          } else {
            this.importTableData = res.data.supplierList
          }
          this.uuid = res.data.uuid
          this.isShowPopupImport = true
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
